export default __webpack_public_path__ + "static/media/logo.abc76e54.svg";